export interface ICfCoreGalleryImage {
    small?: string;
    medium?: string;
    big?: string;
    description?: string;
}
export class CfCoreGalleryImage implements ICfCoreGalleryImage {
    small?: string;
    medium?: string;
    big?: string;
    description?: string;
/**
 * @param {?} obj
 */
constructor(obj: ICfCoreGalleryImage) {
        this.small = obj.small;
        this.medium = obj.medium;
        this.big = obj.big;
        this.description = obj.description;
    }
}

function CfCoreGalleryImage_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryImage.prototype.small;
/** @type {?} */
CfCoreGalleryImage.prototype.medium;
/** @type {?} */
CfCoreGalleryImage.prototype.big;
/** @type {?} */
CfCoreGalleryImage.prototype.description;
}

